export default function Logo({ className = "", size = "default" }) {
  const w = size === "small" ? 170 : 220;
  const h = size === "small" ? 46 : 58;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 300 72"
      width={w}
      height={h}
      className={className}
      data-testid="logo"
    >
      {/* Compass circle */}
      <circle cx="34" cy="36" r="26" fill="none" stroke="#2D5016" strokeWidth="2.5" />
      <circle cx="34" cy="36" r="22" fill="none" stroke="#C8A951" strokeWidth="1" />

      {/* North - Temple */}
      <path d="M34 12 L30 20 L38 20 Z" fill="#2D5016" />
      <line x1="34" y1="20" x2="34" y2="16" stroke="#C8A951" strokeWidth="1.5" />

      {/* South - Pirogue */}
      <path d="M28 54 Q34 50 40 54" fill="none" stroke="#2D5016" strokeWidth="2" />
      <line x1="34" y1="52" x2="34" y2="48" stroke="#C8A951" strokeWidth="1" />

      {/* East - Rice terraces */}
      <path d="M52 34 Q56 36 52 38" fill="none" stroke="#2D5016" strokeWidth="1.5" />
      <path d="M54 32 Q58 36 54 40" fill="none" stroke="#2D5016" strokeWidth="1.5" />

      {/* West - Mask */}
      <ellipse cx="16" cy="36" rx="4" ry="6" fill="none" stroke="#2D5016" strokeWidth="1.5" />
      <circle cx="14" cy="34" r="1" fill="#C8A951" />
      <circle cx="18" cy="34" r="1" fill="#C8A951" />

      {/* Compass center */}
      <line x1="34" y1="22" x2="34" y2="50" stroke="#C8A951" strokeWidth="0.5" opacity="0.5" />
      <line x1="20" y1="36" x2="48" y2="36" stroke="#C8A951" strokeWidth="0.5" opacity="0.5" />
      <circle cx="34" cy="36" r="3" fill="#C8A951" />
      <circle cx="34" cy="36" r="1.5" fill="#2D5016" />

      {/* Decorative line */}
      <line x1="68" y1="14" x2="68" y2="58" stroke="#C8A951" strokeWidth="1" opacity="0.4" />

      {/* VISITMONDE text */}
      <text
        x="78"
        y="30"
        fontFamily="'Playfair Display', serif"
        fontSize="22"
        fontWeight="700"
        fill="#2D5016"
        letterSpacing="1"
      >
        VISITMONDE
      </text>

      {/* Tagline */}
      <text
        x="78"
        y="48"
        fontFamily="'Lato', sans-serif"
        fontSize="8"
        fontWeight="400"
        fill="#A0522D"
        letterSpacing="1"
      >
        LA BOUSSOLE ETHNIQUE
      </text>
    </svg>
  );
}
